export default __webpack_public_path__ + "static/media/3070a1415afb4abb.ed73a52a0c2eb1fa651e50610fdc41a1.svg";